import React from "react";
import logo from "../images/logo_kva_wide.svg";
import Image from "react-bootstrap/Image";

export default class KVALogoWide extends React.Component {
  render() {
    return <Image src={logo} alt="KVA+ Logo" fluid />;
  }
}
